import React, {FC} from "react";
import { Align } from "@baseTypes/baseType";
import cn from "classnames";
import { formatNumber2d } from "@utils/format/number";
import FlexLine from "../../../../../components/elements/flexLine/FlexLine";
import st from './WorksLegend.module.scss';

type WorksLegendProps = {
    remain: number
    total: number
    className?: string
}

const WorksLegend: FC<WorksLegendProps> = ({ remain, total, className }) => {
    return (
        <FlexLine align={Align.End} className={className}>
            <ul className={st.legend}>
                <li className={cn(st.legend__item, st.legend__item_today)}>План на сегодня</li>
                <li className={cn(st.legend__item, st.legend__item_season)}>План на сезон</li>
                <li className={cn(st.legend__item, st.legend__item_total)}>
                    Всего {formatNumber2d(remain)} Га из {formatNumber2d(total, 0)}
                </li>
            </ul>
        </FlexLine>
    )
}

export default WorksLegend;